// extracted by mini-css-extract-plugin
module.exports = {"primaryLabel":"Donut_primaryLabel__xedKU","primaryValue":"Donut_primaryValue__9KZ1i"};